/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, from, of, combineLatest } from 'rxjs';
import { take, filter, map, catchError, switchMap } from 'rxjs/operators';

import { AppState, AppStateUser } from '../app-state.service';
import { tenantGetterService } from '@touchplan/firebase-common';
import { UserSignUpMethod } from '@touchplan/common';
import { LoginComponent } from 'src/app/common/auth/components/login/login.component';
import { fancyDatabase } from '@touchplan/client-firebase';
// import { logger } from '@touchplan/logging';

@Injectable()
export class UserDataResolver {
	constructor(private router: Router, public angularFireAuth: AngularFireAuth, private appState: AppState) {}

	public resolve() {
		return this.appState.user.pipe(
			filter((is) => !!is),
			take(1)
		);
	}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.angularFireAuth.authState
			.pipe(
				take(1),
				switchMap((firebaseUser) => {
					if (!firebaseUser) {
						return of(null);
					}

					return combineLatest([
						this.appState.user,
						//dat side effect
						from(tenantGetterService.getTenantViaAuthId(fancyDatabase, firebaseUser.tenantId)),
					]).pipe(
						map(([user]) => user),
						filter((user) => !!user),
						take(1)
					);
					// return this.appState.user.pipe(
					// 	filter((user) => !!user),
					// 	take(1)
					// );
				})
			)
			.pipe(
				map((userData) => {
					const hasAccess =
						!!userData &&
						!!userData.email &&
						// "authentication handler" signup method: means user record was created by beforeCreate firebase blocking function
						// when user has this state complete singup is required.
						userData.method !== UserSignUpMethod.AuthenticationHandler;
					if (
						(!hasAccess && userData?.method === UserSignUpMethod.AuthenticationHandler) ||
						(!hasAccess && !!userData && !userData.email)
					) {
						this.redirectToCompleteSignup(state);
						return false;
					}
					if (!hasAccess && route.component !== LoginComponent) {
						this.redirectToLogin(state);
						return false;
					}
					if (!hasAccess && route.component === LoginComponent && this.router.url.includes('rally')) {
						return true;
					}
					return hasAccess;
				}),
				catchError((e) => {
					//not using the logger because it's not included in the file yet and this is a blind commit
					console.log('error in resolver', e);
					return of(false);
				})
			);
	}

	public redirectToLogin(state: RouterStateSnapshot) {
		if (state.url.includes('rally')) {
			this.router.navigate(['auth/rally/login']);
		} else {
			this.router.navigate(['/login']);
		}
	}

	public redirectToCompleteSignup(state: RouterStateSnapshot) {
		if (state.url.includes('rally')) {
			this.router.navigate(['auth/rally/signup']);
		} else {
			this.router.navigate(['auth/signup']);
		}
	}
}
